import React, { HTMLProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { Element } from '../base';

interface IProps extends HTMLProps<HTMLAnchorElement> {
    className?: string;
    children?: React.ReactNode;
    rounded?: boolean;
    size?: any;
}

export default function CardImage({
    className,
    children,
    rounded = false,
    size = '',
    ...rest
}: IProps) {
    return (
        <Element
            className={twMerge(
                'bm-card-image',
                'relative',
                'overflow-hidden',
                'rounded-[4px]',
                'shrink-0',
                'after:absolute after:top-0 after:left-0 after:z-[-1]',
                'after:w-full after:h-full',
                "after:bg-[url('https://baomoi-static.bmcdn.me/web/styles/img/logo-baomoi-gray.png')]",
                'after:bg-[center_calc(50%-3px)] after:bg-[length:20%] after:bg-no-repeat',
                'after:opacity-40',
                '[&_figure]:h-full [&_figure]:w-full [&_figure]:overflow-hidden',
                '[&_img]:transition-transform [&_img]:duration-700 [&_img]:object-cover [&_img]:absolute',
                '[&_video]:h-full [&_video]:w-full [&_video]:object-cover [&_video]:absolute',
                className
            )}
            {...rest}
        >
            {children}
        </Element>
    );
}
